/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Reusable Components

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Careers_Section1 from "./sections/Careers_Section1";

function Careers() {
  usePageMeta({
    title: "Cleaning Careers in Ireland | Join Spechs",
    description:
      "Join the Spechs cleaning team. We're hiring professional cleaners across Ireland. Flexible hours, competitive pay.",
    canonical: "https://www.spechs.ie/cleaning/careers/",
  });
  return (
    <SubPageLayout title="Careers">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Careers_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default Careers;
